import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-users-alert'
})
export class Ng1UsersAlertDirective extends UpgradeComponent {
  @Input() userStats;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('usersAlert', elementRef, injector);
  }
}
